import { FluentProvider } from '@fluentui/react-components'
import type { FallbackProps } from 'react-error-boundary'
import { useTheme } from '../../hooks'
import { ErrorFallback } from './ErrorFallback'

// Wraps ErrorFallback with FluentProvider for use outside ProtectedRoute (e.g. main.tsx, AppRouter errorElement)
export const ThemedErrorFallback = (props: FallbackProps) => {
  const { theme } = useTheme()
  return (
    <FluentProvider theme={theme}>
      <ErrorFallback {...props} />
    </FluentProvider>
  )
}
